import { useState } from 'hooks'
import { getHelpComponents } from './selector'

type State = {
	checkbox?: HTMLInputElement
	translationInput?: HTMLInputElement
}

export const Help = (() => {
	const { state, setState } = useState<State>()

	const initCheckbox = () => {
		const { checkbox, translationInput } = state

		if (checkbox == null || translationInput == null) {
			return
		}

		checkbox.addEventListener('change', () => {
			if (checkbox.checked) {
				translationInput.classList.remove('hidden')
			} else {
				translationInput.classList.add('hidden')
			}
		})
	}

	const init = () => {
		setState({ ...getHelpComponents() })
		initCheckbox()
	}

	return {
		init,
	}
})()
